import { render, staticRenderFns } from "./PrintableView.vue?vue&type=template&id=6872c8f4&scoped=true"
import script from "./PrintableView.vue?vue&type=script&lang=ts"
export * from "./PrintableView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872c8f4",
  null
  
)

export default component.exports